import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e00512a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "aria-label": "Page navigation",
  class: "pt-5 pagination-wrapper"
}
const _hoisted_2 = { class: "pagination d-flex justify-content-center align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-24 flycon-chevron-left text-dark rounded-circle p-2"
}, "­", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "page-item mx-1"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "disabled border-0 text-dark rounded-circle p-0 d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    "aria-hidden": "true",
    class: "flycon flycon-start flycon-16 flycon-dots text-dark rounded-circle"
  }, "­")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "border-0 page-link text-dark fw-medium rounded-circle d-flex justify-content-center align-items-center",
  href: "#"
}
const _hoisted_10 = {
  key: 1,
  class: "page-item mx-1"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "disabled border-0 text-dark rounded-circle p-0 d-flex justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    "aria-hidden": "true",
    class: "flycon flycon-start flycon-16 flycon-dots text-dark rounded-circle"
  }, "­")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-24 flycon-chevron-right text-dark rounded-circle p-2"
}, "­", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item mx-1", { disabled: _ctx.pagination.actPage === 1 }])
      }, [
        _createElementVNode("a", {
          class: "border-0 page-link text-dark rounded-circle p-0 d-flex justify-content-center align-items-center",
          href: "#",
          "aria-label": "First",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.navigateTo(_ctx.pagination.actPage - 1), _ctx.scrollToTop()), ["prevent"]))
        }, _hoisted_4)
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item mx-1", { active: _ctx.pagination.actPage === 1 }])
      }, [
        _createElementVNode("a", {
          class: "border-0 page-link text-dark fw-medium rounded-circle d-flex justify-content-center align-items-center",
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigateTo(1), _ctx.scrollToTop()), ["prevent"]))
        }, " 1 ")
      ], 2),
      (_ctx.firstVisiblePage > 2)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesToShow, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass([{ active: _ctx.pagination.actPage === item }, "page-item mx-1 d-flex justify-content-center align-items-center"]),
          onClick: _withModifiers(($event: any) => (_ctx.navigateTo(item), _ctx.scrollToTop()), ["prevent"])
        }, [
          _createElementVNode("a", _hoisted_9, _toDisplayString(item), 1)
        ], 10, _hoisted_8))
      }), 128)),
      (_ctx.lastVisiblePage < _ctx.pagination.totalPages - 1)
        ? (_openBlock(), _createElementBlock("li", _hoisted_10, _hoisted_12))
        : _createCommentVNode("", true),
      (_ctx.pagination.totalPages !== 1)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            class: _normalizeClass(["page-item mx-1", { active: _ctx.pagination.actPage === _ctx.pagination.totalPages }])
          }, [
            _createElementVNode("a", {
              class: "border-0 page-link text-dark fw-medium rounded-circle d-flex justify-content-center align-items-center",
              href: "#",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.navigateTo(_ctx.pagination.totalPages), _ctx.scrollToTop()), ["prevent"]))
            }, _toDisplayString(_ctx.pagination.totalPages), 1)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item mx-1", { disabled: _ctx.pagination.actPage === _ctx.pagination.totalPages }])
      }, [
        _createElementVNode("a", {
          class: "border-0 page-link text-dark rounded-circle p-0 d-flex justify-content-center align-items-center",
          href: "#",
          "aria-label": "Next",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.navigateTo(_ctx.pagination.actPage + 1), _ctx.scrollToTop()), ["prevent"]))
        }, _hoisted_14)
      ], 2)
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.limit) = $event)),
        class: "d-none"
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
          return _createElementVNode("option", {
            value: index,
            key: index,
            selected: _ctx.limit === _ctx.pagination.limit ? 'selected' : ''
          }, _toDisplayString(index), 9, _hoisted_15)
        }), 64))
      ], 512), [
        [_vModelSelect, _ctx.limit]
      ])
    ])
  ]))
}